import { BehaviorSubject, from } from 'rxjs';
import { SocketSubject } from '../../../connect';
/**
 * @internal
 */
export class SocketMock {
    constructor() {
        this.isConnectedSubject = new BehaviorSubject(true);
        this.socketMessagesSubject = new SocketSubject();
    }
    connect(host, options, reconnectOptions) {
        return Promise.resolve(true);
    }
    disconnect() { }
    send(message) {
        return Promise.resolve(this.nextMessage);
    }
    sendForStream(message, onMessage, onError) {
        return from(Promise.resolve(this.nextMessage));
    }
    socketMessages() {
        return this.socketMessagesSubject;
    }
    reset() {
        throw new Error('Method not implemented.');
    }
}
